const paths = {
  layers: 'M2 4 8 1.5 14 4 8 6.5 2 4Zm0 4 6 2.5L14 8M2 12l6 2.5 6-2.5',
  assets: 'M2 2h4v4H2zM10 2h4v4h-4zM2 10h4v4H2zM10 10h4v4h-4z',
  export: 'M8 2v8M5 7l3 3 3-3M3 11v3h10v-3',
  search: 'M11.5 11.5 15 15M12 7a5 5 0 1 1-10 0 5 5 0 0 1 10 0',
  undo: 'M6 3 2 7l4 4M2 7h7a4 4 0 0 1 4 4v2',
  redo: 'M10 3l4 4-4 4M14 7H7a4 4 0 0 0-4 4v2',
} as const;
export function StudioIcon({ name }: { name: keyof typeof paths }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
      <path
        d={paths[name]}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
